module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Cart_16"],"path":[{"$":{"d":"M4,9v1h8v1H3V2H1V1H4V3H15L12,9Zm.5,3A1.5,1.5,0,1,0,6,13.5,1.5,1.5,0,0,0,4.5,12Zm6,0A1.5,1.5,0,1,0,12,13.5,1.5,1.5,0,0,0,10.5,12Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Cart_16.svg
// module id = Ogv9
// module chunks = 1